module.exports = __webpack_public_path__ + "img/logo_expandia.a2c2735b.svg";